import { jsx } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import { validateTidalLicense } from "../../base/index.js";
function Add(props) {
  return /* @__PURE__ */ jsx(
    AddIcon,
    {
      "data-testid": "Add",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Add",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Add.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Add"
};
validateTidalLicense();
export {
  Add
};
//# sourceMappingURL=Add.js.map
